<template>
    <!-- if this is for album, we have only birth-date
    if this is for photo, we have birtdate, with age
    if this is for location, we don't have any dates -->
    <div class="hero is-limegreen" :class="isClass">
        <div class="hero-body centered">
            <div class="hero-image" v-if="albumInfo.image" v-html="albumInfo.image"></div>
        </div>
        <div class="hero-foot">
            <h1 class="embeded animated fadeInRight txt-center" v-text="capitalize(title)"></h1>
            <div class="has-text-centered">
                <h2 class="mtb-40" v-text="shortDesc"></h2>
                <!-- only for album-photo images -->
                <p class="is-size-6" v-if="isType === 'photo'">
                    <span class="has-text-weight-bold is-size-5"> {{ albumInfo.date }}</span>
                </p>
                <p class="is-size-4" v-if="isType === 'photo'" v-html="albumInfo.age"></p>

                <p class="is-size-4" v-if="isType === 'album'" v-html="albumInfo.date"></p>

            </div>
        </div>
    </div>
</template>

<script>
import StringsMixin from '../../mixins/StringsMixin';

export default {
    name:'app-header',
    props: ['info', 'title', 'imagePath', 'isType', 'isClass', 'shortDesc'],
    mixins: [StringsMixin],


    data() {
        console.log('isType: ', this.isType, this.title);
        return {
            // list1: [],
        }
    },


    computed: {

        albumInfo() {
            if(this.info) {

                let item = this.info;
                let thisDate = '';
                // console.log('albumInfo item: ' , this.info, ' if exists: info date: ' , this.info.date, ' or: ' ,this.info.from_date);
                // Date of photo taken
                if(this.isType === 'photo') {
                    if(this.info.date !== undefined || this.info.date !== null) {
                        thisDate = this.info.date;
                    }
                }
                if(this.isType === 'album') {
                    let thisBDate = '';
                    let thisDDate = '';
                    // Date of birth-death
                    if(this.info.from_date !== undefined || this.info.from_date !== null) {
                        thisBDate = this.info.dateFrom;
                    }

                    if(this.info.to_date !== undefined || this.info.to_date !== null) {
                        if(this.info.to_date !== '1970-01-01 00:00:00'){
                            thisDDate = this.info.dateTo;
                        }
                    }
                    if(thisDDate === '') {
                        thisDate = "<i class='fa fa-birthday-cake has-text-danger'></i> " + thisBDate;
                    } else {
                        thisDate = thisBDate + ' - ' + thisDDate;
                    }
                }

                return {
                    age: item.age,
                    image: this.albumImage(item.image),
                    description: item.description,
                    date: thisDate
                }
            }
        }
    },

    methods: {
        albumImage(image) {
            let elem = '<img src="" alt="photo" />';
            if(image === undefined || image === '') {
                return false;
            }
            let path = this.imagePath;

            return '<img src="' + path + '" alt="album" class="is-rounded" />';
        },
    },

}

</script>

<style lang="scss">

@import "../../style/app.scss";
    .hero.is-limegreen {
        margin-top: 60px;
    }
    .hero-foot {
        padding-bottom: 20px;
        p {
            line-height: 1.5;
        }
    }
    #gallery-photo-page, #album-photo {
        .hero-foot {
            // padding-bottom: 0;
            margin-top: -100px;
            background-color: lighten($limegreen, 5%);
            h2 {
                text-shadow: 1px 1px lighten($limegreen, 10%);
                color: $white !important;
                letter-spacing: 1px;
            }
            p {
                text-shadow: 1px 1px lighten($limegreen, 10%);
                color: $white !important;
            }
        }

        .hero-body {
            padding: 0;
            width: 100%;
            min-height: auto !important;
            overflow: hidden;
            max-height: 1400px;
            overflow: hidden;
            text-align: center;
            margin-top: 50px;
            img {
                //width: 100%;
            }
        }
    }


</style>


// WEBPACK FOOTER //
// src/components/layout/HeaderBar.vue